import { InputElementProps, InputRightElement } from '@chakra-ui/react';
import React from 'react';

export const CmInputRightElement: React.FC<InputElementProps> = ({
  children,
  ...rest
}) => {
  // @ts-ignore TS2590
  return <InputRightElement {...{ ...rest }}>{children}</InputRightElement>;
};
